import React from "react";
import MainLayout from "../../components/layout/MainLayout";

// Shopping Guide content component
const ShoppingGuideContent = () => {
  return (
    <div className="w-full bg-guru-floral-white min-h-screen p-4 sm:p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header section with icon and title */}
        <div className="bg-[#FFF5F1] rounded-lg p-4 mb-6">
          <div className="flex items-center">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#C4704B] rounded-lg flex items-center justify-center mr-3 sm:mr-4">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" className="w-6 h-6 sm:w-8 sm:h-8">
                <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
              </svg>
            </div>
            <span className="text-lg sm:text-xl font-semibold">購物指南</span>
          </div>
        </div>

        <h1 className="text-xl sm:text-2xl font-bold mb-6">會員知多d</h1>

        <div className="space-y-6">
          <div className="space-y-4">
            <ol className="list-decimal pl-6 sm:pl-8 space-y-4 text-base sm:text-lg">
              <li>首次落單客人，必須先登記成為Guru Member</li>
              <li>當登記成為瓹窿瓹罅會員後，可即時購買店內所有貨品。</li>
              <li>
                購物滿$450*(以結帳金額計算)可享免運費送貨上門服務(詳細請參閱「送貨及退換貨政策」
                <br />
                購物滿$100* 可免運費選擇 GURU24 門市24小時取貨服務
              </li>
              <li>Guru Member 每消費$1 = 1 Guru Fun(分) (唔准嘥嘢及義賣除外) </li>
              <li>
                Guru Member 90天內消費滿$500，即時自動升級成為 Guru Fans
                <br />
                ** 網店及門市享有九五折優惠(下次購物開始)及 享有每消費$1 = 1 Guru Fun(分)
                <br />
                ⚠️ 升級成為Guru Fan後有效期90日, 到期系統會自動檢查過去90日總消費額, 如消費夠$500會自動再延長會藉90日
              </li>
              <li>
                Guru Member 於30天內消費滿$1000，即時自動升級成為 Guru Family **
                <br />
                網店及門市享有九折優惠(下次購物開始)及 享有消費$1 = 2 Guru Fun(分)
                <br />
                ⚠️升級成為Guru Family後有效期30日, 到期系統會自動檢查過去30日總消費額, 如消費夠$1000會自動再延長會藉30日
              </li>
              <li>所有Guru Fun(分)有效期由發放起計90天有效，如90日到期前有進出紀錄，系統會再自動延長90日。</li>
              <li>所有Guru Fun(分)可以於所有Guru Fun專區換領Coupon或禮物。</li>
              <li>所有Guru Fun(分)不可轉讓，亦不能轉售其他人，一經發現，瓹窿瓹罅保留追討權利。</li>
              <li>Guru Dollar 可於網站或門市當現金使用，亦同樣享有Guru Fun(分)回贈。</li>
              <li>瓹窿瓹罅會員可享有合作商戶之優惠，請留意合作商戶之使用條件及細則。</li>
            </ol>
            <p>*唔准嘥嘢及義賣貨品不計算入免運費之消費金額</p>
            <p>**「定價商品」不會享有任何會員優惠(贈品或折扣)</p>
            <p>會員升級攻略: </p>
            <p>
              會員升級嘅消費係包括所有產品(折扣後計算), 只要滿足指定金額, 系統就會即時升級會員資格, 而我哋最新推出嘅產品就係「Guru
              Dollar」
            </p>
            <p>
              購買咗「Guru Dollar」後, Guru Dollar 會直接入落去你嘅會員帳號, 冇使用限期, 喺網站或門市可以直接當現金使用,
              記得落單之前先去購買Guru Dollar啦, 講到咁白唔係唔識玩啊~ <br />
              ⚠️購買Guru Dollar唔會有任何折扣及回贈⚠️
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#6B7AAC] font-semibold mb-4 text-lg sm:text-xl">Q&A</h2>
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q. 幾時送貨？</h3>
                <p className="text-base sm:text-lg">
                  A. 正常落單及成功付款後7個工作天內會有專人聯絡夾好時間先送到府上😁(節日或預購產品除外)
                  有需要都可以signal或whatsapp: 57439696查詢送貨時間 (⚠️如因節日或推廣活動太多訂單, 有機會超過7日送貨,
                  司機會盡早聯絡通知. 如貨品急用, 可以主動聯絡司機專線57439696, 我們會盡力配合, 多謝體晾🙇)
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q. 幾錢免運費？</h3>
                <p className="text-base sm:text-lg">A. 扣除所有折扣後夠$450免運費(唔准嘥嘢及義賣不計入免運費)</p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q. 邊度唔送？</h3>
                <p className="text-base sm:text-lg">A. 除愉景灣， 大嶼山及禁區，全港九新界，任何屋村，村屋，大廈，工廠都送</p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q. 新單有運費點算？</h3>
                <p className="text-base sm:text-lg">
                  A. 當你再加單(合併訂單)嗰陣系統會自動將運費退做Guru Dollar(無限期使用)，可於下次購物或門市當現金
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q. 司機約我送貨，但其實我未買完，想遲啲先送，點算？</h3>
                <p className="text-base sm:text-lg">
                  A.
                  因為司機係唔會知大家幾時加夠單可以出貨，所以當司機約你，你可以同佢約遲啲先送，或者‼️之後主動聯絡司機專線57439696話可以出貨‼️
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q. 加單有限次數嗎？</h3>
                <p className="text-base sm:text-lg">A. 無。只要我哋未執貨(一般於送貨前1-2個工作天執貨)都可以任加。</p>
              </div>

              <div>
                <h3 className="font-semibold text-base sm:text-lg">Q. 自取幾時可以拎？</h3>
                <p className="text-base sm:text-lg">
                  A. 自取一般1-2個工作天內會執好，會有email及SMS通知，2日都收唔到可以pm打雜專線查詢57448696
                </p>
              </div>
            </div>
          </div>

          <div className="mt-8">
            <p className="text-base sm:text-lg">關於環保回收請到「回收須知」</p>
            <p className="mt-4 text-base sm:text-lg">
              如果仲有其他問題歡迎隨時聯絡
              <br />
              送貨WhatsApp/Signal專線：57439696
              <br />
              打雜WhatsApp/Signal專線：57448696
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

// Main component
const Main = () => {
  return (
    <div className="w-full bg-white">
      <ShoppingGuideContent />
    </div>
  );
};

// Page component
export default function ShoppingGuidePage() {
  return (
    <MainLayout title="購物指南 | GuruGuruHK" url="/article/shopping-guide">
      <Main />
    </MainLayout>
  );
}
